import { gql } from '@apollo/client';

export const SEARCH_SYSTEMS = gql`
  query SearchSystems($searchInput: SearchInput) {
    searchSystems(searchInput: $searchInput) {
      items {
        id
        projectId
        tag
        description
        releaseDate
        unit
        responsibleEngineer
        responsibleFieldEng
        misc1
        ownerId
        updatedTime
        updatedBy
      }
      cursor
    }
  }
`;
export const SAVE_SYSTEMS = gql`
  mutation ($saveSystemInput: SaveSystemInput!) {
    saveSystem(saveSystemInput: $saveSystemInput) {
      systems {
        id
        projectId
        tag
        description
        releaseDate
        unit
        responsibleEngineer
        responsibleFieldEng
        misc1
        ownerId
        updatedTime
        updatedBy
      }
      errors {
        messageKeys
        tag
      }
      deletedIds
    }
  }
`;
